import DeviseFormController from './devise.form.controller';

export default {
    template: require('./devise.form.html'),
    controller: DeviseFormController
};
